function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M100.87,624.88H290.05l83.1-106.62,9.71-11.17-169.93.5V438.66l212.76.61L514.93,325h-182c-74.5,0-146.82-.25-221.31,0-4.25,0-10.71,0-10.71,0v17.85c0,17.06,0,36.48,0,53.54V624.88Z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M932.56,564.2,812.49,473.65v32.58H611.78L761.23,296.49c22.58-32.7,39.26-57.11,42.83-67.82,3.71-11.14,7.14-22.63,7.14-39.27,0-39.26-39.27-46.4-49.39-47.36l-250.26,1.89c-1.14,0-2.32-.11-3.5-.11h-342q-21.74,0-35.69,6.39a40.81,40.81,0,0,0-20.56,20.35c-4.36,9.32-9,22-9,36.69v57.11h14.28c14.28,0,28.13-.07,42.83,0,61.18.18,195.86,0,257,0H650.57L496.31,472.16,382.86,624.88H811.2V657Z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M256,723.33H199.63V856.59H156.86V723.33H100.27v-33.9H256Z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M356.37,823.63q11,0,18.52-4.12a34.93,34.93,0,0,0,12.26-11,44.45,44.45,0,0,0,6.65-15.66,83.22,83.22,0,0,0,1.95-18V689.43h42.77v85.46a106.12,106.12,0,0,1-4.82,32.49,72.58,72.58,0,0,1-14.87,26.37,69.22,69.22,0,0,1-25.56,17.78Q377.76,858,356.37,858q-22.17,0-37.81-6.83t-25.43-18.24a72.52,72.52,0,0,1-14.35-26.49,108.29,108.29,0,0,1-4.56-31.55V689.43H317v85.46a78.17,78.17,0,0,0,2.09,18.37,46.07,46.07,0,0,0,6.78,15.53A33.93,33.93,0,0,0,338,819.62Q345.42,823.64,356.37,823.63Z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M471.38,856.59V689.43h83.46A58.63,58.63,0,0,1,579,694.37a64,64,0,0,1,19.17,13,60.23,60.23,0,0,1,12.65,18.12,49.46,49.46,0,0,1,4.56,20.48,53.67,53.67,0,0,1-2.08,15,55.09,55.09,0,0,1-6,13.54,52.2,52.2,0,0,1-9.52,11.42,56.49,56.49,0,0,1-12.65,8.59l42.51,62.16H579.35l-37.29-53.92H514.15v53.92ZM514.15,769h39.12q7.56,0,13-6.48t5.48-16.6q0-10.35-6.26-16.48T552,723.33H514.15Z"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M691.49,761v95.59H648.72V689.43H682.1l86.33,98.18V689.43H811.2V856.59H776.78Z"
});
function SvgEzTurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EZ_logos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEzTurn);
export default __webpack_public_path__ + "static/media/EZ_turn.dfcc38b6c8c17a4ffa385fb0114f583a.svg";
export { ForwardRef as ReactComponent };